import { Wrapper } from './Wrapper';
import { makeObject } from '../../Util';
import { splitParameters, mergeParameters } from './MergeUtil';

const _ = require('lodash');


export class Stepper {
  constructor(parameters) {
    let { tsParams, otherParams } = splitParameters(parameters);
    
    this.labels = Object.keys(tsParams);
    this.series = this.labels.map(key => tsParams[key]);
    this.otherParams = otherParams;
  }

  getWrappedSeries() {
    return this.series.map(v => new Wrapper(v));
  }

  [Symbol.iterator]() {
    let wrappedSeries = this.getWrappedSeries();
    let labels = this.labels;
    let otherParams = this.otherParams;
    
    return {
      next() {
        let nextAvailableIndices = wrappedSeries.map(v => v.nextIndex());
        
        if (nextAvailableIndices.every(i => i === null)) {
          return { value: null, done: true };
        } else {
          let index = _.min(nextAvailableIndices);
          let values = wrappedSeries.map(s => s.advanceTo(index));
          let tsParams = makeObject(labels, values);

          let args = mergeParameters(tsParams, otherParams);

          let output = { index: index, values: args };

          return {value: output, done: false };
        }
      }
    }
}
}